

<template>
  <!--消息中心-->
  <div
    class="opple-trigger-ifttt"
  >
    <div class="border_title">
      {{ $t('ifttt.buttonAutomation') }}
    </div>
    <div class="border_cont">
      <ul
        class="param_left"
      >
        <li
          v-for="(item, index) in triggerList"
          :key="index"
          :class="{ cur_param: index === activeTriggerIndex }"
          @click="onTriggerItemClick(index)"
        >
          {{ item.Desc }}
        </li>
      </ul>
      <div class="param_right">
        <EnumValueItem 
          v-for="(item, index) in curEnumValues"
          :key="index"
          :enum-data="item"
          :trigger-data="triggerList[activeTriggerIndex]"
          @enumClick="dialogType => onEnumClick(dialogType, index)"
          @editIfttt="onEditIfttt"
          @deleteIfttt="onDeleteIfttt"
        />
      </div>
    </div>
    <OppleAreaDeviceDialog 
      v-if="isAreaDeviceDialogVisible && parentGpNo"
      :title="areaDeviceDialogTitle"
      :visible="isAreaDeviceDialogVisible"
      :required-message-type="requiredMessageType.join(',')"
      :gp-no="parentGpNo"
      @onOk="onBatchedAreaDeviceOk"
      @onClose="handlerAreaDeviceDialogClose"
    />
    <OpDialog
      class="triggerIfttt-opDialog"
      :title="$t('deviceMsg.colorCustomize')"
      :visible="isCustomDialogVisible"
      :is-show-btn="false"
      @onClose="onCustomDialogClose"
    >
      <IftttCustomSet
        v-if="isCustomDialogVisible"
        ref="EleIftttCustomSet"
        :is-regular-triggle="true"
        :is-triggle="true"
        :is-action="true"
        :is-schedule="true"
        :is-navigate="false"
        :is-init-create-request="true"
        :is-jump-back-page="false"
        :is-need-request-triggger="false"
        :is-custom-back="true"
        :show-entry="1"
        :is-inno-trigger="true"
        :gp-no="device?.Gpno"
        @postEvent="postEvent"
        @back="onCustomDialogClose"
      />
    </OpDialog>
  </div>
</template>
<script>
import { Find, Create, Delete } from '@/axios/IFttt.js';
import { clearDeviceTriggerDetailCache, fetchTriggerAbility, getTriggerList } from '@/utils/triggerAbility';
import { fetchIFtttListByTrigger, getIFtttList } from '@/utils/iftttListByTrigger';
import { FindUserAreaTree } from '@/axios/IArea'
import EnumValueItem from './components/EnumValueItem';
import OpDialog from '../common/OpDialog';
import SelectArea from '@/components/common/selectArea.vue';
import OppleAreaDeviceDialog from './components/OppleAreaDeviceDialog';
import IftttDelayTime from "@/page/ifttt/components/IftttDelayTime.vue";
import IftttCustomSet from "@/page/ifttt/iftttCustomSet";
import { alertsuccess, alerterror } from '@/assets/js/common';

export default {
  components: { 
    EnumValueItem,
    OpDialog,
    OppleAreaDeviceDialog,
    SelectArea,
    IftttDelayTime,
    IftttCustomSet
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false
    // },
    device: {
      type: Object,
      default: () => null
    },
    // GpNo: {
    //   type: Number,
    //   default: -1
    // }
  },

  data() {
    return {
      visible: false,
      triggerList: [],
      activeTriggerIndex: 0,
      activeEnumIndex: 0,
      isCustomDialogVisible: false,
      isAreaDeviceDialogVisible: false,
      selectArea: [], // 已选的区域-数据
      checkeddata: [],
      dialogType: null,
      isEditLoading: false,
      GpNo: -1,
      parentGpNo: null,
      areaDeviceDialogTitle: '',
      requiredMessageType: []
    }
  },

  computed: {
    curEnumValues() {
      return this.triggerList[this.activeTriggerIndex]?.EnumValue || [];
    }
  },

  watch: {
    device(value) {
      console.log('mounted mounted', this.device);
      
      if (value && value.VDeviceId) {
        this.init(value);
        this.setGpNo();
      }
    }
  },

  mounted(){ 
    if (this.device) {
      this.init(this.device);
      this.setGpNo();
    }
  },

  created() {
  },

  methods: {
    async setGpNo() {
      const deviceGpNo = this.device.Gpno;
      const deviceParentGpnos = (this.device.ParentGpnos || '').replace(/^@+|@+$/g, '').split('@,@');
      
      const gpNo = Number(deviceParentGpnos[deviceParentGpnos.length - 1]);

      const parentGpNo = Number(deviceParentGpnos[1]);

      this.parentGpNo = parentGpNo;

      if (Number.isInteger(gpNo)) {
        this.GpNo = gpNo;
      } else {
        this.GpNo = Number(deviceGpNo);
      }
    },

    changeEditLoading(bool) {
      this.isEditLoading = bool;
    },

    async onBatchedAreaDeviceOk(data) {
      console.log('data', data, this.triggerList[this.activeTriggerIndex]);
      let ExecuteTaskList = null;
      const trigger = this.triggerList[this.activeTriggerIndex];

      const { device, dialogType } = this;
      const Gpno = data.type === 'area' ? data.selectArea.id : device.Gpno;

      const iftttCommonInfo = {
        Gpno: Gpno,
        TRI_Relation: 0,
        IsManual: false,
        IsEnable: true,
        TriggerType: 0,
        TimePeriod: {
          effectivedate: "2019-01-01,2088-12-31",
          holiday: false,
          time: "00:00",
          weeks: "Mon Tues Wed Thur Fri Sat Sun",
          zone: 0,
        },
        ShowEntry: 1
      };

      const triggerCommonInfo = {
        VDeviceId: device.VDeviceId,
        DeviceName: device.DeviceName,
        AreaName: device.AreaName,
        ClassSku: device.ClassSku,
        IsDel: false
      };

      if (data.type === 'area') {
        ExecuteTaskList = {
          ActionType: 6,
          Gpno: Gpno,
          AreaName: data.selectArea.label,
          Values: [{
            ControlType: 0,
            Value: this.dialogType === 6 ? 1 : 0
          }]
          // curAreaList.map((action) => ({
          //   ControlType: action.Content.ControlType,
          //   Value: action.Content.Value
          // }))
        };
      }
  
      console.log('data.selectDevice', data.selectDevice);

      if (data.type === 'device') {
        const batchedDevice = data.selectDevice;
    
        ExecuteTaskList = {
          ActionType: 0,
          AreaName: batchedDevice.AreaName,
          ChannelId: batchedDevice.ChildId,
          DeviceName: batchedDevice.DeviceName,
          // ClassSku: batchedDevice.ClassSku,
          VDeviceId: batchedDevice.VDeviceId,
          // GpNo: batchedDevice.Gpno,
          ActionList: [{
            MsgType: '0x03110000',
            Values: [{
              KeyId: 1,
              Value: this.dialogType === 6 ? 1 : 0
            }]
          }]
        };
        // iftttReqList = await getElfDefaultIfttt(this.device, {
        //   ActionType: 0,
        //   device: data.selectDevice
        // });
      }

      const curEnum = this.triggerList[this.activeTriggerIndex]?.EnumValue[this.activeEnumIndex];

      const value = curEnum.Value;
      let Value1 = null;
      let Value2 = null;

      if (Array.isArray(value)) {
        Value1 = value[0];
        Value2 = value[1];
      } else {
        Value1 = value;
      }

      let ifttt = {
        ...iftttCommonInfo,
        TriggerList: [{
          ...triggerCommonInfo,
          TriggerList: [{
            ExtraKeyId: trigger.ExtraKeyId,
            KeyId: trigger.KeyID,
            MsgId: trigger.MsgID,
            OperationType: Number(trigger.OperationValue),
            Value1: Number(Value1),
            Value2: Number.isInteger(Number(Value2)) ? Number(Value2) : null,
          }]
        }],
        ExecuteTaskList: [ExecuteTaskList],
        IFtttName: this.dialogType === 6 ? this.$t('ifttt.open') : this.$t('ifttt.close'),
      };

      console.log('ifttt 9999', ifttt);
      this.isAreaDeviceDialogVisible = false;
      const createRes = await Create(ifttt);
      if(createRes.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, createRes.StatusCode)
      } else {
        alerterror(this, createRes.StatusCode)
      }
      clearDeviceTriggerDetailCache(this.device.VDeviceId);
      this.init(this.device);
    },

    postEvent () {
      clearDeviceTriggerDetailCache(this.device.VDeviceId);
      this.init(this.device);
      this.isCustomDialogVisible = false;
    },

    async init(device = this.device) {
      const res = await fetchTriggerAbility(device.VDeviceId);

      const triggerListRes = getTriggerList(res);
      const triggerGroupList = {
        SINGLES: [],
        OTHERS: []
      };

      const triggerControlList = [];
      
      // console.log('GpNoGpNoGpNoGpNo', this.GpNo + '111');
      // debugger
      setLocalStoragItem('ifttt', JSON.stringify({
        treeId: -1,
        GpNo: -1,
        vDeviceId: device.VDeviceId
      }));
      triggerListRes.forEach(item => {
        const TriggerGroupName = item.UI?.TriggerGroup;

        if (TriggerGroupName) {
          if (item.UI?.AllowUsersEditAction === 1) {
            if (triggerGroupList[TriggerGroupName]) {
              triggerGroupList[TriggerGroupName].push(item);
            } else {
              triggerGroupList[TriggerGroupName] = [item];
            }
          } else if (TriggerGroupName === 'UIControl_IftttManagement_Panel') {
            triggerControlList.push(item)
          }
        } else {
          triggerGroupList.SINGLES.push(item);
        }
      });

      console.log('triggerGroupList', triggerGroupList);

      const templateIDs = [];

      triggerControlList.forEach(item => {
        if (Array.isArray(item.UI?.commercialdefaultRecommendation)) {
          item.UI?.commercialdefaultRecommendation.forEach(recommend => {
            console.log('recommend.require', recommend.require);
            
            if (recommend.require !== false) {
              templateIDs.push(recommend.templateID)
            }
          })
        }
      });

      // const needMsgType = new Set();

      // const templatesRes = await GetAutoTemplateById({
      //   id: templateIDs.join(',')
      // });

      // const needDeviceActionList = (templatesRes.Result || []).reduce(
      //   (pre, next) => pre.concat(next.DeviceActionList), []);

      // console.log('needDeviceActionList', needDeviceActionList);

      // needDeviceActionList.forEach(item => {
      //   if (item.Content?.MsgType) {
      //     needMsgType.add(item.Content?.MsgType)
      //   }
      // })

      // this.requiredMessageType = [...needMsgType]

      // console.log('requiredMessageType', this.requiredMessageType);

      const triggerList = [];
      const showTriggers = Object.values(triggerGroupList).reduce((pre, next) => next.concat(pre), [])

      showTriggers.forEach(trigger => {        
        (trigger.OperationType || []).forEach(operation => {
          console.log('trigger', trigger);

          triggerList.push({
            ...trigger,
            OperationName: operation.Name,
            OperationValue: operation.Value,
            EnumValue: (trigger.EnumValue || []).map(item => ({
              ...item,
              iftttList: []
            }))
          })
        })
      });

      this.triggerList = triggerList;

      this.handlerIFttt();
     
    },

    async handlerIFttt() {
      const iftttRes = await fetchIFtttListByTrigger(this.device.VDeviceId, { ShowEntry: 1 });
      
      getIFtttList(iftttRes).forEach(ifttt => {
        (ifttt.TriggerList || []).forEach(triggerItem => {
          (triggerItem.TriggerList || []).forEach(trigger => {
            const triggerIfttt = this.triggerList.find(
              item => item.KeyID === trigger.KeyId &&
              item.ExtraKeyId === trigger.ExtraKeyId &&
              item.OperationValue === trigger.OperationType &&
              item.MsgID === trigger.MsgId
            );

            if (triggerIfttt) {
              (triggerIfttt.EnumValue || []).forEach(enumItem => {
                if (Number(enumItem.Value) === Number(trigger.Value1)) {
                  if (!Array.isArray(enumItem.iftttList)) {
                    enumItem.iftttList = [];
                  };

                  enumItem.iftttList.push(ifttt);
                }
              })
            }
          });
        });
      })
    },  

    handlerAreaDeviceDialogClose() {
      this.isAreaDeviceDialogVisible = false;
    },

    onBatchedDialogOpen() {

    },

    onCustomDialogClose() {
      this.isCustomDialogVisible = false;
    },
    
    onEnumClick(dialogType, index) {
      if ([6, 7].includes(dialogType)) {
        this.dialogType = dialogType;
        this.activeEnumIndex = index;
        this.isAreaDeviceDialogVisible = true;
        this.areaDeviceDialogTitle = dialogType === 6 ? this.$t('ifttt.open') : this.$t('ifttt.close');
      } else {
        console.log('triggger', this.triggerList[this.activeTriggerIndex]);
        const curEnum = this.triggerList[this.activeTriggerIndex]?.EnumValue[index];
        this.isCustomDialogVisible = true;
        this.$nextTick(() => {
          const customSet = this.$refs.EleIftttCustomSet
          if (!customSet) return
          customSet.deviceOption = [{
            VDeviceId: this.device.VDeviceId, 
            DeviceName: this.device.DeviceName, 
            ChannelId: this.device.ChannelId,
            AreaName: this.device.AreaName, 
            ClassSku: this.device.ClassSku,
            ChildId: this.device.ChildId,
            triggle: {
              ...this.triggerList[this.activeTriggerIndex],
              DefaultValue: 
                Array.isArray(curEnum.Value) ? 
                  curEnum.Value.slice() : 
                  curEnum.Value,
              EnumValue: [curEnum]
            }
          }]
        })
      }
    },

    async onEditIfttt(ifttt) {
      const res = await Find({ iftttNo: ifttt.IFT_ID } )

      this.isCustomDialogVisible = true;

      this.$nextTick(() => {
        const customSet = this.$refs.EleIftttCustomSet
        if (!customSet) return
        customSet.iftttSetParamMake(res.Result);
      });
    },

    async onDeleteIfttt(item) {
      const res = await Delete({ iftttNo: item.IFT_ID });

      clearDeviceTriggerDetailCache(this.device.VDeviceId);
      this.init(this.device);
      console.log('handlerDelete', item, res);
    },

    onTriggerItemClick(index) {
      console.log('index', index);
      this.activeTriggerIndex = index;
    },

    setAreaList (val) {
      console.log('val', val);
      
      this.selectArea = val
    },

    handlerNext() {
      this.isBatchedDialogVisible = false;
      this.isAreaDeviceDialogVisible = true;
    },

    deviceValueChange(device) {
      this.checkeddata = device;
      // this.$emit('onOk', device); 
    },

    addDelayTime(timeData) {
      this.triggerList[this.activeTriggerIndex]?.EnumValue[this.activieEnumIndex].iftttList.push(timeData);

      this.isBatchedDialogVisible = false;
    }
  }
}
</script>

<style lang="scss">
.opple-trigger-ifttt {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: "";
      position: absolute;
      left: 0;
      height: 16px;
    }
  }

  .border_cont {
    padding-right: 30px;
    overflow: hidden;

    .param_right {
      padding-bottom: 0;
    }
  }
  .opDialog_body {
    .limit_set {
      margin-top: 0;
    }
    .nextStep {
      display: block;
      width: 100px;
      margin: 20px auto;
      padding: 8px 0;
      border-radius: 4px;
      text-align: center;
      background: #2145A4;
      color: #fff;
      cursor: pointer;
    }
    .ifttt-delay-time {
      margin-top: 180px;
    }
  }
}

.triggerIfttt-opDialog {
  .right_cont {
    height: 570px;

    .dialogTriggle .el-dialog {
      position: relative;
      margin-left:  0;
      margin-top: 0 !important;
      .triggle_cont {
        width: 100%;
      }
    }
  }
  .v-modal {
    display: none;
  }
}
</style>
